// CommentsStore
import { defineStore } from 'pinia'
import { ref } from 'vue';
import { ConstantDefaultCommentGroupsTypes } from '../../Enums/ChoiceEnums';
import * as ChoiceApi from '../ChoiceApi'
import { IDefaultCommentGroupModel, IDefaultCommentModel } from '../Api/Comments';


export const useDefaultCommentsStore = defineStore('defaultComments', () => {
    const defaultCommentGroups = ref<IDefaultCommentGroupModel[]>();
    const defaultComments = ref<IDefaultCommentModel[]>();

    // Default Comments Group
    async function initializeDefaultGroups(): Promise<IDefaultCommentGroupModel[]> {
        if (!defaultCommentGroups.value)
            defaultCommentGroups.value = await ChoiceApi.comments.defaultGroups();
        return defaultCommentGroups.value;
    }

    function clearDefaultGroups(): void {
        defaultCommentGroups.value = undefined;
    }

    // Default Comments
    async function initializeDefaultComments(): Promise<IDefaultCommentModel[]> {
        if (!defaultComments.value)
            defaultComments.value = await ChoiceApi.comments.defaultComments();
        return defaultComments.value;
    }

    function clearDefaultComments(): void {
        defaultComments.value = undefined;
    }

    async function getDefaultCommentInfo(commentId: number): Promise<IDefaultCommentModel | undefined>
    {
        await initializeDefaultComments();
        return defaultComments.value?.find(i => i.dflt_comment_id === commentId);
    }

    // Save a default comment
    async function saveDefaultComment(comment: IDefaultCommentModel)
    {
        await initializeDefaultComments();
        if (!defaultComments.value)
        {
            alert("defaultComments.value is null");
            return;
        }

        if (!comment.dflt_comment_id)
        {
            const commentId = await ChoiceApi.comments.insertDefaultComment(comment.dflt_comment_group_id, comment.description, comment.commentText, comment.alert_types, comment.audienceIds, comment.biller_action_id);

            // Add comment to the store
            comment.dflt_comment_id = commentId;
            defaultComments.value.push(comment);
        }
        else
        {
            //await ChoiceApi.comments.updateDefaultComment(comment.dflt_comment_id, comment.dflt_comment_group_id, comment.description, comment.commentText);
            await ChoiceApi.comments.updateDefaultComment(comment);

            // Update an existing comment in store
            const commentIndex = defaultComments.value.findIndex(i => i.dflt_comment_id === comment.dflt_comment_id);
            if (commentIndex)
                defaultComments.value[commentIndex] = comment;
        }
    }

    // Get the group based on the constant group ID
    async function commentGroupByConstantId(constantDefaultCommentGroupId: number | ConstantDefaultCommentGroupsTypes): Promise<IDefaultCommentGroupModel|undefined>
    {
        await initializeDefaultGroups();
        return defaultCommentGroups.value?.find(i => i.constant_default_comment_group_id === constantDefaultCommentGroupId);
    }

    return {defaultCommentGroups, defaultComments, initializeDefaultGroups, clearDefaultGroups, initializeDefaultComments, clearDefaultComments, getCommentInfo: getDefaultCommentInfo, saveDefaultComment, commentGroupByConstantId};
  });
  